import { useNavigate } from 'react-router-dom'
import Pagination from 'components/Pagination/Pagination'
import { trackCtaClick } from 'services/analyticsService'
import { useTranslation } from 'react-i18next'

const CustomerInsights = () => {
  const navigate = useNavigate()
  const { t } = useTranslation()

  const casesAIAgent = [
    {
      id: 1,
      title: 'customerInsights_page.relatedCases.items.hubDeIa.title',
      description: 'customerInsights_page.relatedCases.items.hubDeIa.description',
      icon: '',
      url: 'hub-de-ia',
    },
    {
      id: 2,
      title: 'customerInsights_page.relatedCases.items.leitorDePedidos.title',
      description: 'customerInsights_page.relatedCases.items.leitorDePedidos.description',
      icon: '',
      url: 'leitor-de-pedidos',
    },
    {
      id: 3,
      title: 'customerInsights_page.relatedCases.items.iaAssistenteDeManutencao.title',
      description:
        'customerInsights_page.relatedCases.items.iaAssistenteDeManutencao.description',
      icon: '',
      url: 'ia-assistente-de-manutencao',
    },
    {
      id: 4,
      title: 'customerInsights_page.relatedCases.items.iaAssistenteRh.title',
      description: 'customerInsights_page.relatedCases.items.iaAssistenteRh.description',
      icon: '',
      url: 'ia-assistente-rh',
    },
  ]

  const handleRelatedCaseCtaClick = (caseItem) => {
    const ctaText = t('customerInsights_page.relatedCases.cta')

    trackCtaClick({
      cta_name: 'ia_case_related_case_click',
      cta_location: 'ia_case',
      page_name: 'customer_insights',
      case_title: t(caseItem.title),
      destination_path: `/${caseItem.url}`,
      cta_text: ctaText,
    })

    navigate(`/${caseItem.url}`)
  }

  return (
    <>
      <section className="main-container DataCases">
        <header className="main-container-top">
          <div className="text">
            <h2>{t('customerInsights_page.header.title')}</h2>
          </div>

          <div className="image-container">
            <img
              src="/assets/Cases/DataCases/notebook-datacase2.png"
              alt={t('customerInsights_page.header.imageAlt')}
            />
          </div>
        </header>

        <div className="main-content">
          <div className="main-content-primary">
            <h3 className="NoBorder">
              {t('customerInsights_page.sections.challenge.title')}
            </h3>

            <ul>
              <li>{t('customerInsights_page.sections.challenge.items.item1')}</li>
              <li>{t('customerInsights_page.sections.challenge.items.item2')}</li>
              <li>{t('customerInsights_page.sections.challenge.items.item3')}</li>
            </ul>

            <hr />

            <h3>{t('customerInsights_page.sections.approach.title')}</h3>

            <ul>
              <li>{t('customerInsights_page.sections.approach.items.item1')}</li>
              <li>{t('customerInsights_page.sections.approach.items.item2')}</li>
              <li>{t('customerInsights_page.sections.approach.items.item3')}</li>
              <li>{t('customerInsights_page.sections.approach.items.item4')}</li>
              <li>{t('customerInsights_page.sections.approach.items.item5')}</li>
              <li>{t('customerInsights_page.sections.approach.items.item6')}</li>
              <li>{t('customerInsights_page.sections.approach.items.item7')}</li>
            </ul>

            <hr />

            <h3>{t('customerInsights_page.sections.result.title')}</h3>

            <ul>
              <li>{t('customerInsights_page.sections.result.items.item1')}</li>
              <li>{t('customerInsights_page.sections.result.items.item2')}</li>
              <li>{t('customerInsights_page.sections.result.items.item3')}</li>
            </ul>

            <div className="DataHashtag">
              <button>{t('customerInsights_page.tags.item1')}</button>
              <button>{t('customerInsights_page.tags.item2')}</button>
              <button>{t('customerInsights_page.tags.item3')}</button>
              <button>{t('customerInsights_page.tags.item4')}</button>
            </div>
          </div>
        </div>
      </section>

      <section className="main-cases-container">
        <h2 className="title">{t('customerInsights_page.relatedCases.title')}</h2>

        <span className="subtitle">
          {t('customerInsights_page.relatedCases.subtitle')}
        </span>

        <Pagination data={casesAIAgent} itemsPerPage={4}>
          {(currentItems) => (
            <div className="main-cases-content">
              {currentItems.map((caseItem) => (
                <article key={caseItem.id} className="case-card">
                  <span className="icon">{caseItem.icon}</span>

                  <h3>{t(caseItem.title)}</h3>
                  <p>{t(caseItem.description)}</p>

                  <a
                    href={`/${caseItem.url}`}
                    onClick={(e) => {
                      e.preventDefault()
                      handleRelatedCaseCtaClick(caseItem)
                    }}
                  >
                    {t('customerInsights_page.relatedCases.cta')} →
                  </a>
                </article>
              ))}
            </div>
          )}
        </Pagination>
      </section>
    </>
  )
}

export default CustomerInsights
